import React, { useState } from "react";
import LoadingSpinner from "../../../../components/Loadder"; 
import { postData, getData } from "../../../../serverRequest";

export default function IspReportForm(props) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [entityName, setEntityName] = useState("");  
  const [isp, setIsp] = useState("");  
  const [ipAddress, setIpAddress] = useState("");
  const [subnet, setSubnet] = useState("");
  const [gateway, setGateway] = useState("");
  const [dns1, setDns1] = useState("");
  const [dns2, setDns2] = useState("");
  const [bandwidth, setBandwidth]  = useState("");
  const [connectionType, setConnectionType]  = useState("");
  const [rdsPort, setRdsPort]  = useState("");
  const [routerUrl, setRouterUrl]  = useState("");
  const [routerUsername, setRouterUsername]  = useState("");
  const [routerPassword, setRouterPassword]  = useState("");
  const [dmzHost, setDmzHost]  = useState("");
  const [ssidName, setSsidName]  = useState("");  
  const [ssidPassword, setSsidPassword]  = useState("");
  const [apUrl, setApUrl]  = useState("");
  const [apUsername, setApUsername]  = useState("");
  const [apPassword, setApPassword]  = useState("");
  const [subscriptionPeriod, setSubscriptionPeriod] = useState("");
  const [totalEntities, setTotalEntities] = React.useState([]);  
  const filterEntityData = (entities_data) => {
    //console.log(tickets_data);
    let totalEntity = [];
    if (entities_data) {
      for (let i = 0; i < entities_data.length; i++) {
        totalEntity.push(entities_data[i])
      }
    }

    setTotalEntities(totalEntity);
    return ({ "total": totalEntity })
  }

   React.useEffect(() => {
     async function fetchData() {
        setLoading(true);
       let resData = await getData('/api/company?admin=1')
       let entities_data = resData['data']['entities']
       console.log(entities_data);
       let entitiesData = await filterEntityData(entities_data)
 
 
       setLoading(false);
     }
     fetchData();
 
 
   }, []) 

  const handleSubmit = async (event) => {
    event.preventDefault();  
    setLoading(true);
  
    const formData = {
      'entity_name': entityName ? entityName : '',
      'isp': isp ? isp : '',
      'ip_address': ipAddress ? ipAddress : '',
      'subnet': subnet ? subnet :'',
      'gateway': gateway ? gateway : '',
      'dns_1': dns1 ? dns1 :'',
      'dns_2': dns2 ? dns2 : '',
      'bandwidth': bandwidth ? bandwidth : '',
      'connection_type': connectionType ? connectionType : '',
      'rds_port_number': rdsPort ? rdsPort : '',
      'router_url': routerUrl ? routerUrl : '',
      'router_username': routerUsername ? routerUsername : '',
      'router_password': routerPassword ? routerPassword : '',
      'dmz_host': dmzHost ? dmzHost : '',
      'ssid_name': ssidName ? ssidName : '',
      'ssid_password': ssidPassword ? ssidPassword : '',
      'ap_url': apUrl ? apUrl : '',
      'ap_username': apUsername ? apUsername : '',
      'ap_password': apPassword ? apPassword : '',
    };
  
    try {
      console.log(formData)
      const res = await postData('/api/product/ispdetail/', formData);
      console.log(res);
      if (res['data']['code'] === 200) {
        setLoading(false);
        setShowModal(true);
        alert('Isp report submitted successfully');
        window.location.href = '/admin/reports/ispReport';
      } else {
        alert('Isp report submission failed');
        console.error('Failed to submit form:', res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setLoading(false);
    }
  };  
  
  return (
    <div className="isp-report-form-container p-4 pt-0 min-h-screen w-full">
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <form onSubmit={handleSubmit}> 
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            <div className="rounded-t bg-white mb-6 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">ISP Report Form </h6>
              </div>
            </div>            
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">  
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="entityName">Entity Name</label>
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="entityName"
                    value={entityName}
                    onChange={(e) => setEntityName(e.target.value)}
                  >
                    <option value="">Select Entity</option>
                    {totalEntities.map((entity, index) => (
                      <option key={index} value={entity.company_code}>
                        {entity.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="isp">ISP</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="isp" defaultValue={isp} onChange={(e) => setIsp(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="ipAddress">IP Address</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="ipAddress" defaultValue={ipAddress} onChange={(e) => setIpAddress(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="subnet">Subnet</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="subnet" defaultValue={subnet} onChange={(e) => setSubnet(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="gateway">Gateway</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="gateway" defaultValue={gateway} onChange={(e) => setGateway(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="dns1">DNS 1</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="dns1" defaultValue={dns1} onChange={(e) => setDns1(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="dns2">DNS 2</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="dns2" defaultValue={dns2} onChange={(e) => setDns2(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="bandwidth">BandWidth</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="bandwidth" defaultValue={bandwidth} onChange={(e) => setBandwidth(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="connectionType">Connection Type</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="connectionType" defaultValue={connectionType} onChange={(e) => setConnectionType(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="rdsPort">RDS Port No.</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="rdsPort" defaultValue={rdsPort} onChange={(e) => setRdsPort(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="routerUrl">Router URL</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="routerUrl" defaultValue={routerUrl} onChange={(e) => setRouterUrl(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="routerUsername">Router Username</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="routerUsername" defaultValue={routerUsername} onChange={(e) => setRouterUsername(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="routerPassword">Router Password</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="routerPassword" defaultValue={routerPassword} onChange={(e) => setRouterPassword(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="dmzHost">DMZ Host</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="dmzHost" defaultValue={dmzHost} onChange={(e) => setDmzHost(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="ssidName">SSID Name</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="ssidName" defaultValue={ssidName} onChange={(e) => setSsidName(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="ssidPassword">SSID Password</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="ssidPassword" defaultValue={ssidPassword} onChange={(e) => setSsidPassword(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="apUrl">AP URL</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="apUrl" defaultValue={apUrl} onChange={(e) => setApUrl(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="apUsername">AP Username</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="apUsername" defaultValue={apUsername} onChange={(e) => setApUsername(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="apPassword">AP Password</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="apPassword" defaultValue={apPassword} onChange={(e) => setApPassword(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="text-center mt-6 lg:w-3/12 px-4"> 
              <input
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-4 w-full ease-linear transition-all duration-150"
                type="Submit"
                value="Submit"
              />                            
            </div>
          </div>
        </form>
      )}
    </div>
  );
}
